import { render, staticRenderFns } from "./AffinityList.vue?vue&type=template&id=3e0ed4a5&scoped=true"
import script from "./AffinityList.vue?vue&type=script&lang=js"
export * from "./AffinityList.vue?vue&type=script&lang=js"
import style0 from "./AffinityList.vue?vue&type=style&index=0&id=3e0ed4a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0ed4a5",
  null
  
)

export default component.exports